/**
 * Permission Keys Constants
 *
 * Centralized permission key definitions to avoid magic strings throughout the codebase.
 * Import these constants instead of hardcoding permission keys.
 *
 * Note: This file mirrors api/src/lib/permissions.ts to keep web and api in sync.
 */

export const PERMISSION_KEYS = {
  // Export permissions
  EXPORT_APPLICANT_TABLE_CSV: 'export:applicant_table_csv',

  // User management permissions
  MANAGE_USER_ACCESS: 'manage:user_access',
  MANAGE_REMOVE_USER: 'manage:remove_user',

  // Analytics permissions
  //
  // `manage:` rather than `read:` because it gates both directions: seeing the
  // figures at all, and (together with an ADMIN/OPS role) editing the monthly
  // budget. Editing without reading is not a coherent state — the upsert
  // replaces a whole month rather than patching it.
  //
  // NOTE the polarity too: unlike every other key here, this one RESTRICTS
  // rather than widens. The others are checked as `hasRole(...) || hasPermission(...)`,
  // so a role can stand in for the grant. Marketing spend must be checked as
  // the grant ALONE. Clients hand portal logins to their outside marketing
  // agencies, and those users are ordinary Employee rows holding ADMIN /
  // RECRUITER / OPS — indistinguishable from staff — so any role fallback
  // hands agencies the budget figures the gate exists to hide from them.
  MANAGE_MARKETING_COSTS: 'manage:marketing_costs',
} as const

// Type for permission keys (useful for TypeScript)
export type PermissionKey =
  (typeof PERMISSION_KEYS)[keyof typeof PERMISSION_KEYS]
